/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'
import OfferList from 'components/offer-list/offer-list'
import AddOrBuy from '../../add-or-buy/add-or-buy'
import Card from 'components/card'
import QuantityInformation from '../quantity-information'
import { BestOfferLink } from '../best-offer-link/best-offer-link'
import { regItemProps } from '../reg-item-props'
import RegItemCardLayout from '../reg-item-card-layout'
import { ReservationStatusAction } from '../guest-actions/reservation-status-action'

export const ReservableProductRegItemCard = (props, context) => {
  const {
    regItem: {
      eligibleForDeferredPayment,
      offers,
      isReserved,
      quantity,
      quantityNeeded,
    },
    giftStatusContent,
    openReservationModal,
    regItem,
    reservationByCurrentVisitor,
    openRedirectModal,
  } = props
  const { registry, isMobile } = context

  const Wrapper = ({ children }) => {
    if (isMobile) {
      return <Card>{children}</Card>
    }
    return children
  }

  const regItemLink = (child) => {
    return (
      <BestOfferLink offers={offers} regItem={regItem}>
        {child}
      </BestOfferLink>
    )
  }

  const actions = () => {
    if (reservationByCurrentVisitor) {
      return (
        <ReservationStatusAction reservation={reservationByCurrentVisitor} />
      )
    }

    return (
      <AddOrBuy
        regItem={regItem}
        offers={offers}
        registry={registry}
        reservation={reservationByCurrentVisitor}
      />
    )
  }

  return (
    <Wrapper>
      <RegItemCardLayout
        actions={actions()}
        giftStatusContent={giftStatusContent}
        imageCTA={null}
        regItem={regItem}
        regItemLinkDecorator={regItemLink}
        quantityInformation={
          <QuantityInformation
            quantity={quantity}
            quantityNeeded={quantityNeeded}
          />
        }
      />
    </Wrapper>
  )
}

ReservableProductRegItemCard.propTypes = {
  giftStatusContent: PropTypes.string,
  openReservationModal: PropTypes.func.isRequired,
  regItem: PropTypes.shape(regItemProps).isRequired,
  reservationByCurrentVisitor: PropTypes.object,
  openRedirectModal: PropTypes.func.isRequired,
}

ReservableProductRegItemCard.contextTypes = {
  isFacebookApp: PropTypes.bool,
  isMobile: PropTypes.bool,
  registry: PropTypes.object,
}

ReservableProductRegItemCard.defaultProps = {
  giftStatusContent: null,
  reservationByCurrentVisitor: null,
}

export default ReservableProductRegItemCard
